import React, { useState } from 'react';

import { session } from 'services/session';
import { api } from 'services/api';

import SearchModal from './search-modal';
import CreateStory from './create-story';
import CopyLink from './copy-link';

import dynamicInfo from 'images/icons/dynamic-info.svg';
import pasteIcon from 'images/icons/paste.svg';
import './create-link.scss';

function CreateLink() {
	/* STATE */
	const [product, setProduct] = useState('');
	const [story, setStory] = useState(null);
	const [link, setLink] = useState(null);
	const [dynamic, setDynamic] = useState(true);
	const [page, setPage] = useState('link');
	const [error, setError] = useState('');

	/* METHODS */
	function pasteFromClipboard() {
		navigator.clipboard.readText().then((text) => {
			setProduct(text);
		});
	}

	function reset() {
		setProduct('');
		setStory(null);
		setLink(null);
		setDynamic(true);
		setPage('link');
	}

	function createNewLink() {
		const url = `/api/v0/publishers/${session.orgId}/bam_links/`;
		const params = {
			url: product,
			exclusive_match_requested: !dynamic,
			edit_id: story.edit_id,
		};

		api.post(url, params).then((response) => {
			setError('');
			setLink(response.data.data[0]);
			setPage('copy');
		}).catch((e) => {
			if (e && e?.code === 4001) {
				e.message = 'Invalid Product URL';
			}
			setError(e?.message || 'Something went wrong, please try again');
		});
	}

	/* RENDER */
	const searchModal = page === 'modal' ? (
		<SearchModal
			setStory={setStory}
			setPage={setPage}
		/>
	) : null;

	const createStory = page === 'story' ? (
		<CreateStory />
	) : null;

	const copyLink = page === 'copy' ? (
		<CopyLink
			link={link}
			reset={reset}
		/>
	) : null;

	const flexButton = product ? (
		<div className="delete" onClick={() => {
			setProduct('');
			setStory(null);
		}}>
			x
		</div>
	) : (
		<div className="paste"
			onClick={pasteFromClipboard}>
			<img src={pasteIcon} alt="paste button" />
		</div>
	);

	const storyName = story ? story.name : 'Search for a Story';
	const storyField = product ? (
		<div className="story-field"
			onClick={() => setPage('modal')}>
			<div className="title">Story (Required)</div>
			<div className="search-container">
				<div className="inner-container">
					<span className="narrativ-icon search" />
					<span className={`story-input ${story ? 'active' : ''}`}>
						{storyName}
					</span>
				</div>
				<span className="dropdown-icon"></span>
			</div>
		</div>
	) : null;

	const descriptors = story ? (
		<div className="descriptors">
			<div className="channel">
				<span>Channel:</span>
				{story.channel}
			</div>
			<div className="date">
				<span>Publisher Date:</span>
				{story.publication_date}
			</div>
		</div>
	) : null;

	const createButton = product && story ? (
		<div className="create-button"
			onClick={createNewLink}>
			Create Link
		</div>
	) : null;

	const createLink = page === 'link' ? (
		<div>
			<div className="header">Narrativ Smartlink Creator</div>
			<div className="switch-row">
				<div className="info">
					Dynamic Link
					<img className="info-icon" src={dynamicInfo} alt="info" />
				</div>
				<div className={`switch ${dynamic ? 'dynamic' : ''}`}
					onClick={() => setDynamic(!dynamic)}>
					<span></span>
				</div>
			</div>
			<textarea className={`product-url ${product ? 'focus' : ''}`}
				placeholder="Paste product URL here..."
				onChange={(e) => setProduct(e.target.value)}
				value={product}
				spellCheck={false}
			/>
			{flexButton}
			{storyField}
			{descriptors}
			{createButton}
		</div>
	) : null;

	return (
		<div className="create-link">
			{createLink}
			{searchModal}
			{createStory}
			{copyLink}
		</div>
	);
}

export default CreateLink;
